

// formatuje date za pomocą momentjs

angular.module('theme.core.filters')
.filter('moment', function() {
	return function(date, format) {
		return moment(date).format(format)
	}
})
